import { AmendmentCard } from './AmendmentCard';

interface Amendment {
  id: string;
  title?: string; // nome da instituição
  description: string;
  value: number;
}

interface AmendmentSectionProps {
  title: string;
  icon: string;
  category: 'health' | 'diverse' | 'education' | 'infrastructure';
  // Chave real da categoria (ex.: 'SAÚDE', 'EDUCAÇÃO') para uso em componentes externos
  categoryKey?: string;
  amendments: Amendment[];
  className?: string;
  headerColorClasses?: { bgClass: string; textClass: string; borderClass?: string };
  cardColorClasses?: { textClass?: string; borderClass?: string; hoverClass?: string };
  onSelectAmendment?: (id: string) => void;
}

const categoryColors = {
  health: 'bg-success',
  diverse: 'bg-diverse',
  education: 'bg-info',
  infrastructure: 'bg-warning'
};

export function AmendmentSection({ title, icon, category, categoryKey, amendments, className, headerColorClasses, cardColorClasses, onSelectAmendment }: AmendmentSectionProps) {
  return (
    <section className={`mb-12 secao-${category} ${className || ''}`}
      data-category-key={categoryKey || ''}
    >
      <div className="flex items-center mb-6">
        <div className={`${headerColorClasses ? `${headerColorClasses.bgClass} ${headerColorClasses.textClass} border ${headerColorClasses.borderClass || ''}` : `${categoryColors[category]} text-white`} p-3 rounded-lg mr-4`}>
          <i className={`${icon} text-xl`}></i>
        </div>
        <h3 className={`text-2xl font-bold font-inter ${headerColorClasses?.textClass ? headerColorClasses.textClass : 'text-foreground'}`}>
          {title}
        </h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {amendments.map((amendment) => (
          <AmendmentCard
            key={amendment.id}
            title={amendment.title}
            description={amendment.description}
            value={amendment.value}
            category={category}
            colorClasses={cardColorClasses}
            onClick={onSelectAmendment ? () => onSelectAmendment(amendment.id) : undefined}
          />
        ))}
      </div>
    </section>
  );
}
